import React, { FunctionComponent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useDebouncedCallback } from 'use-debounce'

import { campaignDetailsEvent, trackAddedEvent } from 'Helpers/tagManager'
import { Desktop, Mobile } from 'Shared/components/Responsive'
import CustomScrollDiv from 'Shared/custom/CustomScrollDiv'
import {
  setTracksToInitialState,
  setTrackToInitialState,
} from 'Redux/actions/trackActions'
import { getAmountOfCampaigns } from 'Redux/selectors/campaigns'
import { getIsFirstCampaign, getUserId } from 'Redux/selectors/auth'
import TrackSuccessfullyAdded from 'Containers/CreateCampaignWithoutSignup/components/TrackSuccessfullyAdded'
import AddSpotifySearchModal from 'Containers/CreateCampaignPage/components/AddSpotifySearchModal'
import { CampaignPlatformTypeEnum, Track } from 'Types/index'

import { addHandler, findTrackHandler } from './helpers'
import CheckTrackFromSearch from '../CheckTrackFromSearch'
import { AddSpotifyTrackSearchProps } from './AddSpotifyTrackSearchProps'
import { AddTrackWrapper, WrapperRelative } from './styles'
import AddSpotifyTrackSearchInput from '../AddSpotifyTrackSearchInput'

const AddSpotifyTrackSearch: FunctionComponent<AddSpotifyTrackSearchProps> = ({
  accessToken,
  track,
  tracks,
  isAuth,
  isChangedTrack,
  setIsChangedTrack,
  campaignType,
  errorText,
  setErrorText,
}) => {
  const dispatch = useDispatch()
  const userId = useSelector(getUserId)
  const isFirstCampaign = useSelector(getIsFirstCampaign)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)
  const campaignNumber = amountOfCampaigns + 1

  const [searchText, setSearchText] = useState('')

  const [isSearch, setIsSearch] = useState(false)

  const [isShowSearchModal, setIsShowSearchModal] = useState(false)

  const setTracksToInit = () => {
    dispatch(setTracksToInitialState())
  }

  const [debouncedFindTrack] = useDebouncedCallback((searchText: string) => {
    findTrackHandler({
      searchText,
      setIsSearch,
      setErrorText,
      accessToken,
      dispatch,
      setTracksToInit,
    })
  }, 1000)

  useEffect(() => {
    if (!searchText) {
      setErrorText('')
      setTracksToInit()
    } else {
      searchText.length > 0 && debouncedFindTrack(searchText)
    }
  }, [searchText])

  useEffect(() => {
    if (errorText) {
      setIsShowSearchModal(false)
    }
  }, [errorText])

  const setGTMevent = (track: Track) => {
    trackAddedEvent(
      track,
      Boolean(isFirstCampaign),
      // @ts-ignore
      campaignType,
      campaignNumber,
      userId
    )
    // @ts-ignore
    userId && campaignDetailsEvent(campaignType, campaignNumber)
  }

  const handleSetSearchToInitial = () => {
    setSearchText('')
    setTracksToInit()
  }

  const handleChangeSpotifyTrack = () => {
    dispatch(setTrackToInitialState())
  }

  const onCheckAddHandler = (apiURL: string) => {
    addHandler({
      handleSetSearchToInitial,
      setIsChangedTrack,
      dispatch,
      isAuth,
      setGTMevent,
      accessToken,
      setErrorText,
      apiURL,
    })
  }

  // @ts-ignore
  return (
    <>
      <Desktop>
        <AddTrackWrapper>
          {track ? (
            <TrackSuccessfullyAdded
              track={track}
              handleChangeSpotifyTrack={handleChangeSpotifyTrack}
            />
          ) : (
            <AddSpotifyTrackSearchInput
              isSearch={isSearch}
              searchText={searchText}
              setSearchText={setSearchText}
              errorText={errorText}
              setErrorText={setErrorText}
            />
          )}

          {tracks && (
            <WrapperRelative>
              <CustomScrollDiv length={tracks.length}>
                <CheckTrackFromSearch
                  // @ts-ignore
                  tracks={tracks}
                  onCheck={onCheckAddHandler}
                />
              </CustomScrollDiv>
            </WrapperRelative>
          )}
        </AddTrackWrapper>
      </Desktop>

      <Mobile>
        <AddTrackWrapper>
          {track && (
            <TrackSuccessfullyAdded
              track={track}
              handleChangeSpotifyTrack={handleChangeSpotifyTrack}
            />
          )}
          {!track && !isShowSearchModal && (
            <AddSpotifyTrackSearchInput
              isSearch={isSearch}
              searchText={searchText}
              setSearchText={setSearchText}
              errorText={errorText}
              setErrorText={setErrorText}
              setIsShowModal={() => setIsShowSearchModal(true)}
            />
          )}
          {!track && isShowSearchModal && (
            <AddSpotifySearchModal
              searchValue={searchText}
              setSearchValue={setSearchText}
              accessToken={accessToken}
              isAuth={isAuth}
              modal={isShowSearchModal}
              toggle={() => setIsShowSearchModal(x => !x)}
              track={track}
              tracks={tracks}
              isChangedTrack={isChangedTrack}
              setIsChangedTrack={setIsChangedTrack}
              campaignType={CampaignPlatformTypeEnum.SPOTIFY}
            />
          )}
        </AddTrackWrapper>
      </Mobile>
    </>
  )
}

export default AddSpotifyTrackSearch
